// End of the given YYYY-MM-DD calendar day (23:59:59) in the browser's local
// timezone, returned as a UTC ISO string. Built from date parts so the result
// never depends on how a date-only string happens to be parsed.
export function endOfLocalDayISO(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d, 23, 59, 59, 0).toISOString();
}
